<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.7045 3.35208H10.299V2.68461C10.299 2.24743 9.94393 1.89258 9.50675 1.89258C9.06956 1.89258 8.71438 2.24743 8.71438 2.68461V3.35208H7.4759C4.93584 3.35208 2.87695 5.41134 2.87695 7.9516V17.0028C2.87695 19.543 4.93584 21.6023 7.4759 21.6023C10.188 21.6023 13.8165 21.6023 16.5276 21.6023C19.0677 21.6023 21.1266 19.543 21.1266 17.0028V7.9516C21.1266 5.41134 19.0677 3.35208 16.5276 3.35208H15.2892V2.68461C15.2892 2.24743 14.934 1.89258 14.4968 1.89258C14.0596 1.89258 13.7045 2.24743 13.7045 2.68461V3.35208ZM19.5429 10.0227V17.0028C19.5429 18.6682 18.1933 20.0182 16.5276 20.0182C13.8165 20.0182 10.188 20.0182 7.4759 20.0182C5.81121 20.0182 4.46066 18.6682 4.46066 17.0028V10.0227H19.5429ZM8.3082 15.3435L10.4761 17.5121C10.7853 17.8214 11.2875 17.8214 11.5966 17.5121L15.6963 13.4125C16.0054 13.1034 16.0054 12.6015 15.6963 12.2925C15.3871 11.9834 14.8849 11.9834 14.5758 12.2925L11.0364 15.832L9.42773 14.2234C9.1186 13.9144 8.61733 13.9144 8.3082 14.2234C7.99907 14.5325 7.99907 15.0344 8.3082 15.3435ZM15.2892 4.93604V5.60362C15.2892 6.0407 14.934 6.39555 14.4968 6.39555C14.0596 6.39555 13.7045 6.0407 13.7045 5.60362V4.93604H10.299V5.60362C10.299 6.0407 9.94393 6.39555 9.50675 6.39555C9.06956 6.39555 8.71438 6.0407 8.71438 5.60362V4.93604H7.4759C5.81121 4.93604 4.46066 6.28621 4.46066 7.9516V8.4386H19.5429V7.9516C19.5429 6.28621 18.1933 4.93604 16.5276 4.93604H15.2892Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'StateScheduled'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
